import React, { Component } from 'react'
import { Table } from 'reactstrap'
import moment from 'moment'

import { openModalWithContainer } from './../reducers/modals'
import Resource from '../Resource'

export default class PostsContainer extends Component {
  render() {
    const { me } = this.props
    return (
      <Resource collection path={['posts']} placeholder={[]}>
        {(posts, { onCreateItem, onUpdateItem, onDeleteItem, dispatch }) => (
          <Resource collection path={['users']} placeholder={[]}>
            {(users) => (
              <div id="PostsContainer">
                <h3 className="tab-header">
                  News Updates
                  <div style={{ float: 'right' }}>
                    <div
                      className="btn btn-sm btn-success mr-2"
                      onClick={() =>
                        dispatch(
                          openModalWithContainer('WalkTestInviteContainer', {
                            post: null,
                            onSave: onCreateItem,
                            me: me,
                          })
                        )
                      }
                    >
                      Add 6MWT
                    </div>

                    <div
                      className="btn btn-sm btn-primary"
                      onClick={() =>
                        dispatch(
                          openModalWithContainer('PostContainer', {
                            post: null,
                            onSave: onCreateItem,
                            me: me,
                          })
                        )
                      }
                    >
                      Add News Update
                    </div>
                  </div>
                </h3>
                <Table className="table-element">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Author</th>
                      <th>Date Published</th>
                      <th>Recipient</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {posts.map((post, idx) => (
                      <tr key={idx}>
                        <td>{post.title}</td>
                        <td>{post.user?.username}</td>
                        <td>{moment(post.createdAt).format('MMMM DD, YYYY')}</td>
                        <td>
                          {post.recipientId
                            ? (users.find((u) => u.id === post.recipientId) || {}).username
                            : 'Everyone'}
                        </td>
                        <td>
                          {/* <a
                            href="#"
                            onClick={() =>
                              dispatch(
                                openModalWithContainer('PostContainer', {
                                  post: post,
                                  me: me,
                                  onDelete: onDeleteItem,
                                  onSave: onUpdateItem,
                                })
                              )
                            }
                          >
                            Edit
                          </a> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Resource>
        )}
      </Resource>
    )
  }
}
